<script>
  import Pie from './charts/pie.svelte';
  import Table from './charts/table.svelte';
  import Columns from './charts/columns.svelte';

  export let data;
  export let pieConf = undefined;
  export let columns = undefined;
  export let columnsConf = undefined;
</script>

<div class="lt-stats">
  {#if pieConf}
    <Pie { data } conf={ pieConf } />
  {/if}
  {#if columns}
    <Table { data } { columns }>
      <svelte:fragment slot="copiable"><slot name="copiable">&#128203;</slot></svelte:fragment>
    </Table>
  {/if}
  {#if columnsConf}
    <Columns class={ $$props.class } { data } columns={ columnsConf } />
  {/if}
</div>